import script from "./MantenedorGrokEstudyoo.vue?vue&type=script&setup=true&lang=js"
export * from "./MantenedorGrokEstudyoo.vue?vue&type=script&setup=true&lang=js"

import "./MantenedorGrokEstudyoo.vue?vue&type=style&index=0&id=29203bbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29203bbb"]])

export default __exports__